import { c as _c } from "react/compiler-runtime";
import { Dialog as ChakraDialog, Portal } from '@chakra-ui/react';
import * as React from 'react';
import { CloseButton } from './close-button';
interface DialogContentProps extends ChakraDialog.ContentProps {
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement | null>;
  backdrop?: boolean;
}
export const DialogContent = React.forwardRef<HTMLDivElement, DialogContentProps>(function DialogContent(props, ref) {
  const $ = _c(17);
  let children;
  let portalRef;
  let rest;
  let t0;
  let t1;
  if ($[0] !== props) {
    ({
      children,
      portalled: t0,
      portalRef,
      backdrop: t1,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = portalRef;
    $[3] = rest;
    $[4] = t0;
    $[5] = t1;
  } else {
    children = $[1];
    portalRef = $[2];
    rest = $[3];
    t0 = $[4];
    t1 = $[5];
  }
  const portalled = t0 === undefined ? true : t0;
  const backdrop = t1 === undefined ? true : t1;
  const t2 = !portalled;
  let t3;
  if ($[6] !== backdrop) {
    t3 = backdrop && <ChakraDialog.Backdrop />;
    $[6] = backdrop;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== children || $[9] !== ref || $[10] !== rest) {
    t4 = <ChakraDialog.Positioner><ChakraDialog.Content ref={ref} {...rest} asChild={false}>{children}</ChakraDialog.Content></ChakraDialog.Positioner>;
    $[8] = children;
    $[9] = ref;
    $[10] = rest;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== portalRef || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <Portal container={portalRef} disabled={t2}>{t3}{t4}</Portal>;
    $[12] = portalRef;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
});
export const DialogCloseTrigger = React.forwardRef<HTMLButtonElement, ChakraDialog.CloseTriggerProps>(function DialogCloseTrigger(props, ref) {
  const $ = _c(6);
  let t0;
  if ($[0] !== props.children || $[1] !== ref) {
    t0 = <CloseButton ref={ref} size="sm">{props.children}</CloseButton>;
    $[0] = props.children;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props || $[4] !== t0) {
    t1 = <ChakraDialog.CloseTrigger insetEnd="2" position="absolute" top="2" {...props} asChild={true}>{t0}</ChakraDialog.CloseTrigger>;
    $[3] = props;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
});
export const DialogRoot = ChakraDialog.Root;
export const DialogFooter = ChakraDialog.Footer;
export const DialogHeader = ChakraDialog.Header;
export const DialogBody = ChakraDialog.Body;
export const DialogBackdrop = ChakraDialog.Backdrop;
export const DialogTitle = ChakraDialog.Title;
export const DialogDescription = ChakraDialog.Description;
export const DialogTrigger = ChakraDialog.Trigger;
export const DialogActionTrigger = ChakraDialog.ActionTrigger;